import apiClient from '../client/api-client'

const shares = 'shares'
const sharingResources = 'sharingResources'

export default {
  /*
      Load user shares
  */
  async loadUserShares() {
    try {
      const { data } = await apiClient.get(`${shares}?userMeta=true`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
      Create share link to share via email or social network
  */
  async createExternalShareLink(payload) {
    try {
      const { data } = await apiClient.post(`${shares}?emailNotify=true`, payload)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
      Get share by id
  */
  async shareDetailWithId(shareId) {
    // eslint-disable-next-line no-useless-catch
    try {
      const { data } = await apiClient.get(`${shares}/${shareId}?grantorMeta=true`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
    Get share by id
*/
  async shareDetailWithIdAndToken(shareId) {
    // eslint-disable-next-line no-useless-catch
    try {
      const { data } = await apiClient.get(`${shares}/${shareId}?grantorMeta=true&token=true`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
     Delete share by sharing id and resource id
 */
  async revokeSharedResourceId(shareId, resourceId) {
    // eslint-disable-next-line no-useless-catch
    try {
      return await apiClient.delete(`${shares}/${shareId}/${sharingResources}/${resourceId}`)
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
     Get share with a subject
 */
  async getShareByEmail(email) {
    try {
      return await apiClient.get(`${shares}`, {
        params: {
          subject: email
        }
      })
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
     Create a document share
 */
  async createShare(payload) {
    try {
      if (!payload.resourceType || !payload.subject) {
        throw Error('resourceType and subject is required')
      }
      let sharingResource = {
        resourceType: payload.resourceType,
        permissions: ['read'],
        expiresIn: payload.duration === 'never' ? undefined : payload.duration
      }
      if (payload.id !== null) sharingResource.resourceId = payload.id
      const { data } = await apiClient.post(`${shares}?emailNotify=${payload.emailNotify}`, {
        sharingType: payload.sharingType,
        subject: payload.subject,
        status: 'pending',
        sharingResources: [sharingResource]
      })
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
     Update a document share
 */
  async updateShare(sharingId, payload) {
    try {
      if (!sharingId) {
        throw Error('missing sharingId')
      }
      let sharingResource = {
        resourceType: payload.resourceType,
        permissions: ['read'],
        expiresIn: payload.duration === 'never' ? undefined : payload.duration,
        metadata: {}
      }
      if (payload.id !== null) sharingResource.resourceId = payload.id
      const {
        data
      } = await apiClient.put(
        `${shares}/${sharingId}/${sharingResources}?notify=${payload.emailNotify}`,
        [sharingResource]
      )
      return data
    } catch (err) {
      throw new Error(err)
    }
  }
}
